import i18next from 'i18next';
import ChainedBackend from 'i18next-chained-backend';
import Backend from 'i18next-xhr-backend';
import { reactI18nextModule } from '~/utils/translate';
import languageDetector from './language-detector';
import { formatCurrency, formatNumber } from './numbers';

i18next
  .use(languageDetector)
  .use(ChainedBackend)
  .use(reactI18nextModule)
  .init({
    backend: {
      backends: [
        Backend, // primary
        Backend, // from libraries
      ],
      backendOptions: [
        {
          loadPath: '/translations/{{ns}}/{{lng}}.json',
        },
        {
          // The libraries project uses this structure
          loadPath: '/lib-translations/{{lng}}/{{ns}}.json',
        },
      ],
    },
    fallbackLng: {
      default: ['en'],
    },
    debug: ENV_ID !== 'production',

    // have a common namespace used around the full app
    ns: ['translations'],
    defaultNS: 'translations',

    interpolation: {
      escapeValue: false, // not needed for react!!
      formatSeparator: ',',
      format: (value, format, lng) => {
        if (format === 'currency') return formatCurrency(value, lng);
        if (format === 'number') return formatNumber(value, lng);
        return value;
      },
    },

    react: {
      wait: true,
    },
  });

export default i18next;
